var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "outer supply-chain" },
    [
      _c(
        "el-tabs",
        {
          staticStyle: { "margin-bottom": "30px" },
          on: { "tab-click": _setup.changePage },
          model: {
            value: _setup.pageTab,
            callback: function ($$v) {
              _setup.pageTab = $$v
            },
            expression: "pageTab",
          },
        },
        [
          _c("el-tab-pane", { attrs: { label: "选品池", name: "no" } }),
          _c("el-tab-pane", { attrs: { label: "供应链池", name: "yes" } }),
        ],
        1
      ),
      _c(
        "search-panel",
        {
          attrs: { "show-btn": "", flex: "" },
          on: {
            getList: function ($event) {
              return _setup.getList(1)
            },
          },
        },
        [
          _setup.isReset
            ? [
                _c(
                  "div",
                  [
                    _c("p", [_vm._v("商品类目")]),
                    _c(_setup.ChangeCat, {
                      attrs: { "parent-id": 1 },
                      on: { change: _setup.handleChange },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  [
                    _c("p", [_vm._v("供应商")]),
                    _c("el-input", {
                      attrs: {
                        clearable: "",
                        placeholder: "请输入内容",
                        size: "mini",
                      },
                      on: {
                        clear: function ($event) {
                          return _setup.getList(1)
                        },
                      },
                      model: {
                        value: _setup.params.relationSupplierName,
                        callback: function ($$v) {
                          _vm.$set(_setup.params, "relationSupplierName", $$v)
                        },
                        expression: "params.relationSupplierName",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  [
                    _c("p", [_vm._v("商品名称")]),
                    _c("el-input", {
                      attrs: {
                        clearable: "",
                        placeholder: "请输入内容",
                        size: "mini",
                      },
                      on: {
                        clear: function ($event) {
                          return _setup.getList(1)
                        },
                      },
                      model: {
                        value: _setup.params.goodsName,
                        callback: function ($$v) {
                          _vm.$set(_setup.params, "goodsName", $$v)
                        },
                        expression: "params.goodsName",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  [
                    _c("p", { staticStyle: { width: "100%" } }, [
                      _vm._v("优选商品ID"),
                    ]),
                    _c("el-input", {
                      attrs: {
                        size: "mini",
                        placeholder: "请输入内容",
                        clearable: "",
                        maxlength: "19",
                      },
                      on: {
                        blur: function ($event) {
                          return _setup.setFixed(_setup.params, "goodsId")
                        },
                      },
                      model: {
                        value: _setup.params.goodsId,
                        callback: function ($$v) {
                          _vm.$set(_setup.params, "goodsId", $$v)
                        },
                        expression: "params.goodsId",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  [
                    _c("p", [_vm._v("供应商状态")]),
                    _c(
                      "el-select",
                      {
                        attrs: {
                          placeholder: "请选择",
                          size: "mini",
                          clearable: "",
                        },
                        on: {
                          change: function ($event) {
                            return _setup.getList(1)
                          },
                        },
                        model: {
                          value: _setup.params.isRelation,
                          callback: function ($$v) {
                            _vm.$set(_setup.params, "isRelation", $$v)
                          },
                          expression: "params.isRelation",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "关联供应商", value: 1 },
                        }),
                        _c("el-option", {
                          attrs: { label: "未关联供应商", value: 0 },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  [
                    _c("p", [_vm._v("选品中心状态")]),
                    _c(
                      "el-select",
                      {
                        attrs: {
                          placeholder: "请选择",
                          size: "mini",
                          clearable: "",
                        },
                        on: {
                          change: function ($event) {
                            return _setup.getList(1)
                          },
                        },
                        model: {
                          value: _setup.params.scState,
                          callback: function ($$v) {
                            _vm.$set(_setup.params, "scState", $$v)
                          },
                          expression: "params.scState",
                        },
                      },
                      [
                        _c("el-option", { attrs: { label: "上架", value: 1 } }),
                        _c("el-option", { attrs: { label: "下架", value: 0 } }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _c(
            "el-button",
            {
              attrs: { slot: "button-right", size: "mini" },
              on: {
                click: function ($event) {
                  return _setup.operation("reset")
                },
              },
              slot: "button-right",
            },
            [_vm._v(" 重 置 ")]
          ),
          _c(
            "el-button",
            {
              attrs: { slot: "button-right", size: "mini", type: "primary" },
              on: { click: _setup.addBtn },
              slot: "button-right",
            },
            [_vm._v(" 新增商品 ")]
          ),
        ],
        2
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _setup.loading,
              expression: "loading",
            },
          ],
          ref: "multipleTable",
          staticClass: "tableBox",
          staticStyle: { width: "100%" },
          attrs: {
            data: _setup.tableData,
            "element-loading-text": "拼命加载中",
            "row-key": "id",
            "header-cell-style": {
              background: "#f5f7fa",
            },
            size: "medium",
          },
        },
        [
          _c("el-table-column", {
            attrs: { type: "expand" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-table",
                      {
                        staticStyle: { "margin-left": "148px" },
                        attrs: {
                          data: row.tradeGoodsSkuDtoList || [],
                          size: "medium",
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: { label: "商品规格", width: "300" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "wd-flex wd-flex-align-center",
                                      },
                                      [
                                        _c("el-image", {
                                          staticStyle: {
                                            width: "50px",
                                            height: "50px",
                                          },
                                          attrs: {
                                            src: scope.row.imageIds,
                                            "preview-src-list": [
                                              scope.row.imageIds,
                                            ],
                                            fit: "cover",
                                          },
                                        }),
                                        _c(
                                          "div",
                                          { staticClass: "margin-l5" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(scope.row.specValue) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: { prop: "id", label: "规格ID" },
                        }),
                        _c("el-table-column", {
                          attrs: { label: "店铺销售价（元）", width: "180" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      " " + _vm._s(+scope.row.sellPrice) + " "
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: "订货价（元）",
                            width: "180",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(scope.row.supplyPrice || 0)
                                      ),
                                    ]),
                                    scope.row.supplyType === 1
                                      ? _c("div", [_vm._v("(直接设置)")])
                                      : scope.row.supplyType === 2
                                      ? _c("div", [
                                          _vm._v(
                                            "(以佣金比例" +
                                              _vm._s(
                                                Number(
                                                  (
                                                    scope.row.supplyPercent *
                                                    100
                                                  ).toFixed(0)
                                                )
                                              ) +
                                              "%设置)"
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "estimatedProfit",
                            label: "预估毛利（%)",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          +(
                                            scope.row.estimatedProfit * 100
                                          ).toFixed(2)
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "goodsId", label: "优选商品ID", width: "100" },
          }),
          _c("el-table-column", {
            attrs: { prop: "goodsName", label: "商品名称", "min-width": "100" },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "backendCategoryPath",
              label: "商品类目",
              "min-width": "150",
            },
          }),
          _c("el-table-column", {
            attrs: { prop: "tagName", label: "商品标签" },
          }),
          _c("el-table-column", {
            attrs: { prop: "salesSumTrue", label: "店铺销量" },
          }),
          _c("el-table-column", {
            attrs: { label: "预估毛利（%）" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    row.lowEstimatedProfit === row.highEstimatedProfit
                      ? _c("span", [
                          _vm._v(
                            " " +
                              _vm._s(
                                +(row.lowEstimatedProfit * 100).toFixed(2)
                              ) +
                              " "
                          ),
                        ])
                      : _c("span", [
                          _vm._v(
                            " " +
                              _vm._s(
                                +(row.lowEstimatedProfit * 100).toFixed(2)
                              ) +
                              " ~ " +
                              _vm._s(
                                +(row.highEstimatedProfit * 100).toFixed(2)
                              ) +
                              " "
                          ),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "订货价（元）" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    row.lowSupplyPrice === row.highSupplyPrice
                      ? _c("span", [
                          _vm._v(" " + _vm._s(+row.lowSupplyPrice) + " "),
                        ])
                      : _c("span", [
                          _vm._v(
                            " " +
                              _vm._s(+row.lowSupplyPrice) +
                              " ~ " +
                              _vm._s(+row.highSupplyPrice) +
                              " "
                          ),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "店铺销售价（元）" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    row.lowSellPrice === row.highSellPrice
                      ? _c("span", [
                          _vm._v(" " + _vm._s(+row.lowSellPrice) + " "),
                        ])
                      : _c("span", [
                          _vm._v(
                            " " +
                              _vm._s(+row.lowSellPrice) +
                              " ~ " +
                              _vm._s(+row.highSellPrice) +
                              " "
                          ),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "供应商" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _vm._v(" " + _vm._s(row.relationSupplierName) + " "),
                    row.relationSupplierStatusStr
                      ? _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              effect: "dark",
                              content: row.relationSupplierStatusStr,
                              placement: "top",
                            },
                          },
                          [_c("i", { staticClass: "el-icon-warning red" })]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "选品中心状态" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _vm._v(
                      " " + _vm._s(row.scState === 1 ? "上架" : "下架") + " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "退货地址", width: "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("div", [
                      _vm._v("收货人：" + _vm._s(row.refundReceiveName)),
                    ]),
                    _c("div", [
                      _vm._v("收货手机号：" + _vm._s(row.refundReceiveMobile)),
                    ]),
                    _c("div", [
                      _vm._v("收货地址：" + _vm._s(row.refundAddress)),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "操作", width: "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    row.isRelation === 1
                      ? _c(
                          "el-link",
                          {
                            attrs: { type: "danger", underline: false },
                            on: {
                              click: function ($event) {
                                return _setup.operation("delete", row)
                              },
                            },
                          },
                          [_vm._v(" 解除关联 ")]
                        )
                      : _vm._e(),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "text",
                          loading: row.updateToErpLoading,
                        },
                        on: {
                          click: function ($event) {
                            return _setup.updateToErp(row)
                          },
                        },
                      },
                      [_vm._v("铺货/更新到ERP")]
                    ),
                    row.ttcIsOnSale === null
                      ? _c(
                          "el-link",
                          {
                            attrs: { type: "primary", underline: false },
                            on: {
                              click: function ($event) {
                                return _setup.operation("syncToTTC", row)
                              },
                            },
                          },
                          [_vm._v(" 铺货到中国土特产 ")]
                        )
                      : _vm._e(),
                    _c("br"),
                    _c(
                      "el-link",
                      {
                        attrs: { type: "primary", underline: false },
                        on: {
                          click: function ($event) {
                            return _setup.operation("setGoodsOnOff", row)
                          },
                        },
                      },
                      [_vm._v(" 设置商品上下架 ")]
                    ),
                    _c("br"),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _setup.tableData && _setup.tableData.length > 0
        ? _c("el-pagination", {
            attrs: {
              "current-page": _setup.params.currentPage,
              "page-sizes": [10, 20, 30, 50],
              "page-size": _setup.params.nowPageSize,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _setup.params.count,
            },
            on: {
              "size-change": _setup.handleSizeChange,
              "current-change": _setup.handleCurrentChange,
            },
          })
        : _vm._e(),
      _c(_setup.AddGoods, { ref: "AddGoodsRef" }),
      _c(_setup.setGoodsOnOff, { ref: "setGoodsOnOffRes" }),
      _c(_setup.SyncToTTC, {
        ref: "syncToTTCRef",
        on: { syncToTTCSuccess: _setup.syncToTTCSuccess },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _setup.showSyncDialog,
            title: "同步商品",
            width: "700px",
            "before-close": _setup.closeSyncDialog,
          },
          on: {
            "update:visible": function ($event) {
              _setup.showSyncDialog = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "sync-dialog-content" },
            [
              _c("div", { staticClass: "sync-subtitle" }, [
                _vm._v(
                  " 将下方ID商品同步到优选店铺&供应链&选品中心/ERP，并关联供应商。（仅支持优选店铺商品/优选推荐商品/选品中心商品同步） "
                ),
              ]),
              _c(
                "el-form",
                { ref: "syncForm", attrs: { "label-width": "120px" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品ID" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入商品ID",
                          clearable: "",
                          maxlength: "19",
                        },
                        model: {
                          value: _setup.syncGoodsId,
                          callback: function ($$v) {
                            _setup.syncGoodsId = $$v
                          },
                          expression: "syncGoodsId",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "关联供应商" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入供应商ID",
                          clearable: "",
                          maxlength: "19",
                        },
                        model: {
                          value: _setup.syncRelationSupplierId,
                          callback: function ($$v) {
                            _setup.syncRelationSupplierId = $$v
                          },
                          expression: "syncRelationSupplierId",
                        },
                      }),
                      _c("div", { staticClass: "tip-text" }, [
                        _vm._v(
                          " 若需要关联选品中心的源头商家，请在上方输入源头商家ID。 "
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "铺品渠道" } },
                    [
                      _c(
                        "el-checkbox-group",
                        {
                          model: {
                            value: _setup.syncQudaoType,
                            callback: function ($$v) {
                              _setup.syncQudaoType = $$v
                            },
                            expression: "syncQudaoType",
                          },
                        },
                        [
                          _c(
                            "el-checkbox",
                            { attrs: { disabled: "", label: 1 } },
                            [
                              _vm._v("农博优选 "),
                              _c("span", { staticStyle: { color: "gray" } }, [
                                _vm._v(
                                  "（已属于优选店铺商品不同步仅修改上下架状态。）"
                                ),
                              ]),
                            ]
                          ),
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _setup.syncYxIsOnSale,
                                callback: function ($$v) {
                                  _setup.syncYxIsOnSale = $$v
                                },
                                expression: "syncYxIsOnSale",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("上架"),
                                _c("span", { staticStyle: { color: "red" } }, [
                                  _vm._v(
                                    "（若商品未关联供应商，订单由农博优选店发货，请谨慎操作）"
                                  ),
                                ]),
                              ]),
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("下架"),
                              ]),
                            ],
                            1
                          ),
                          _c("el-checkbox", { attrs: { label: 2 } }, [
                            _vm._v("渠道选品中心"),
                            _c("span", { staticStyle: { color: "gray" } }, [
                              _vm._v(
                                "（已属于选品中心商品不同步仅修改为上架状态。）"
                              ),
                            ]),
                          ]),
                          _c("el-checkbox", { attrs: { label: 3 } }, [
                            _vm._v("ERP"),
                            _c("span", { staticStyle: { color: "red" } }, [
                              _vm._v(
                                "（若商品未关联供应商，订单由农博优选店发货，请谨慎操作）"
                              ),
                            ]),
                          ]),
                          _c("el-checkbox", { attrs: { label: 4 } }, [
                            _vm._v("中国土特产 "),
                            _c("span", { staticStyle: { color: "gray" } }, [
                              _vm._v(
                                "（已属于优选店铺商品不同步仅修改上下架状态。）"
                              ),
                            ]),
                          ]),
                          _c(
                            "el-radio-group",
                            {
                              attrs: {
                                disabled: !_setup.syncQudaoType.includes(4),
                              },
                              model: {
                                value: _setup.syncTTCIsOnSale,
                                callback: function ($$v) {
                                  _setup.syncTTCIsOnSale = $$v
                                },
                                expression: "syncTTCIsOnSale",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("上架"),
                                _c("span", { staticStyle: { color: "red" } }, [
                                  _vm._v(
                                    "（若商品未关联供应商，订单由农博优选店发货，请谨慎操作）"
                                  ),
                                ]),
                              ]),
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("下架"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _setup.closeSyncDialog } }, [
                _vm._v("取 消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _setup.syncLoading },
                  on: { click: _setup.submitSync },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }